import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Lang } from '@/i18n/translations';

interface SettingsState {
  sfx: number; // 0-100
  music: number; // 0-100
  haptic: boolean;
  lefty: boolean;
  colorBlind: boolean;
  tapZone: number; // 70-130 (%)
  /** UI language. Persisted across sessions; defaults to browser language
   * if recognized, otherwise English. */
  lang: Lang;
  /** True once the new-player onboarding (name + victory shout) has run. */
  onboarded: boolean;
  setSfx: (v: number) => void;
  setMusic: (v: number) => void;
  setHaptic: (v: boolean) => void;
  setLefty: (v: boolean) => void;
  setColorBlind: (v: boolean) => void;
  setTapZone: (v: number) => void;
  setLang: (v: Lang) => void;
  setOnboarded: (v: boolean) => void;
}

function defaultLang(): Lang {
  if (typeof navigator === 'undefined') return 'en';
  const b = (navigator.language || 'en').toLowerCase();
  if (b.startsWith('vi')) return 'vi';
  if (b.startsWith('zh')) return 'zh';
  if (b.startsWith('ja')) return 'ja';
  if (b.startsWith('ko')) return 'ko';
  if (b.startsWith('th')) return 'th';
  return 'en';
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      sfx: 80,
      music: 60,
      haptic: true,
      lefty: false,
      colorBlind: false,
      tapZone: 100,
      lang: defaultLang(),
      onboarded: false,
      setSfx: (v) => set({ sfx: v }),
      setMusic: (v) => set({ music: v }),
      setHaptic: (v) => set({ haptic: v }),
      setLefty: (v) => set({ lefty: v }),
      setColorBlind: (v) => set({ colorBlind: v }),
      setTapZone: (v) => set({ tapZone: v }),
      setLang: (v) => set({ lang: v }),
      setOnboarded: (v) => set({ onboarded: v }),
    }),
    { name: 'cd:settings' }
  )
);
